export default __webpack_public_path__ + "static/media/video.d9ea3934.png";